import { Component, forwardRef, input, InputSignal } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from '../../form/abstracts';
import { TimeFieldComponent } from "./components/time-field/time-field.component";

@Component({
  selector: 'app-time-fields',
  standalone: true,
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    TimeFieldComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: forwardRef(() => TimeFieldsComponent),
    },
  ],
  templateUrl: './time-fields.component.html',
  styleUrls: ['./time-fields.component.scss'],
})
export class TimeFieldsComponent extends BaseFormField<string | null> {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlNameStartTime: InputSignal<string | null> = input<string | null>(null);
  public formControlNameEndTime: InputSignal<string | null> = input<string | null>(null);

  public viewMoreOptionsTimes: boolean = false;

  
  public handleMoreOptionsTimes() {
    this.viewMoreOptionsTimes = !this.viewMoreOptionsTimes;
  }
}
